export const handleIconSource = (iconName) => {
    try {
        console.log(`../assets/icons/${iconName}.png`)
        return require(`../assets/icons/${iconName}.png`)
    }
    catch (e) {
        return null
    }

}